export default __webpack_public_path__ + "static/media/342.5582863a.jpg";